import { render } from "./Focus.vue?vue&type=template&id=e3d50d1c"
import script from "./Focus.vue?vue&type=script&lang=js"
export * from "./Focus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__